import Text from '@redbubble/design-system/src/Text';
import styles from './SEO.module.scss';

interface SEOTextProps {
  seoFooterText: string;
}

export const SEOText: React.FC<SEOTextProps> = ({ seoFooterText }) => {
  return (
    <Text
      muted
      type="body2"
      display="block"
      marginBottom="s"
      className={styles.seoText}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: noDangerouslySetInnerHtml
      dangerouslySetInnerHTML={{
        __html: seoFooterText,
      }}
    />
  );
};
